import React, { FunctionComponent } from 'react';

import { Button, ButtonProps } from 'src/components/atoms/Button';
import * as styles from './styles';

export const TextButton: FunctionComponent<ButtonProps> = ({
  children,
  ...buttonProps
}: ButtonProps) => (
  <Button css={styles.textButton} {...buttonProps}>
    {children}
  </Button>
);
